import moment from "moment";
import { extendMoment } from "moment-range";

extendMoment(moment);
export default moment;
